import React, { Component } from "react";
import { Switch, withRouter, Route } from "react-router-dom";
import Overview from "../Overview/Overview";
import CurbsideCommunication from "../HeatSpot/heatSpot";
import Deal from "../Deals/deals";
import Posts from "../Posts/posts";
import Events from "../Events/events";
import Messages from "../Messages/messages";
import Appointments from "../Appointments/appointments";
import Reservations from "../Reservations/reservations";
import Orders from "../Orders/Orders";
import OrderNotifications from "../OrderNotifications/orderNotifications";
import Menu from "../Menu/menu";
import Album from "../Album/album";
import Visitors from "../Visitors/visitors";
import Activity from "../Activity/activity";
import MyAccount from "../MyAccount/myAccount";
import PrivateRoute from "../../RouteTypes/privateRoute";
import AccountRoute from "../../RouteTypes/accountRoute";
import ErrorPage from "../../../Helper/ErrorPage/errorPage";
import { routeName } from "../../../../src/Service/env";
import { connect } from "react-redux";

import "./routes.css";

class Routes extends Component {
  render() {
    const { user } = this.props;
    return (
      <div>
        <Switch>
          <PrivateRoute
            exact
            path={`/${routeName}/Dashboard/Overview`}
            component={Overview}
            user={user}
          />
          <PrivateRoute
            exact
            path={`/${routeName}/Dashboard/CurbsideCommunication`}
            component={CurbsideCommunication}
            user={user}
          />
          <PrivateRoute
            exact
            path={`/${routeName}/Dashboard/Deal`}
            component={Deal}
            user={user}
          />
          <PrivateRoute
            exact
            path={`/${routeName}/Dashboard/Posts`}
            component={Posts}
            user={user}
          />
          <PrivateRoute
            exact
            path={`/${routeName}/Dashboard/Events`}
            component={Events}
            user={user}
          />
          <PrivateRoute
            exact
            path={`/${routeName}/Dashboard/Messages`}
            component={Messages}
            user={user}
          />
          <PrivateRoute
            exact
            path={`/${routeName}/Dashboard/Appointments`}
            component={Appointments}
            user={user}
          />
          <PrivateRoute
            exact
            path={`/${routeName}/Dashboard/Reservations`}
            component={Reservations}
            user={user}
          />
          <PrivateRoute
            exact
            path={`/${routeName}/Dashboard/Orders`}
            component={Orders}
            user={user}
          />
          <PrivateRoute
            exact
            path={`/${routeName}/Dashboard/OrderNotifications`}
            component={OrderNotifications}
            user={user}
          />
          <PrivateRoute
            exact
            path={`/${routeName}/Dashboard/Menu`}
            component={Menu}
            user={user}
          />
          <PrivateRoute
            exact
            path={`/${routeName}/Dashboard/Album`}
            component={Album}
            user={user}
          />
          <PrivateRoute
            exact
            path={`/${routeName}/Dashboard/Visitors`}
            component={Visitors}
            user={user}
          />
          <PrivateRoute
            exact
            path={`/${routeName}/Dashboard/Activity`}
            component={Activity}
            user={user}
          />
          <AccountRoute
            exact
            path={`/${routeName}/Dashboard/MyAccount`}
            component={MyAccount}
            user={user}
          />

          <Route path="*" component={ErrorPage} />
        </Switch>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.loginResponse.results,
  };
};
export default withRouter(connect(mapStateToProps, null)(Routes));
